import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Badge, {BadgeColor} from 'ui-library/Badge';

import type {PredictionBatchStatus} from './PredictionBatchTypes';

const STATUS_BADGE_CONFIG: Record<PredictionBatchStatus, {color: BadgeColor; label: string}> = {
  PENDING: {color: BadgeColor.GRAY, label: 'Pending'},
  RUNNING: {color: BadgeColor.YELLOW, label: 'Running'},
  SUCCEEDED: {color: BadgeColor.GREEN_FILLED, label: 'Succeeded'},
  FAILED: {color: BadgeColor.RED, label: 'Failed'},
};

interface PredictionBatchStatusBadgeProps {
  status: PredictionBatchStatus;
}

export default function PredictionBatchStatusBadge({status}: PredictionBatchStatusBadgeProps): JSX.Element {
  const config = STATUS_BADGE_CONFIG[status];
  return (
    <div
      aria-label={`Status: ${config.label}`}
      {...getTestProps({component: 'PredictionBatchStatusBadge', element: 'root'})}
    >
      <Badge color={config.color}>{config.label}</Badge>
    </div>
  );
}
